import { useReducer } from 'react';

import type { CourseResourceEnum } from '@/Enums/enum';
import { cn } from '@/lib/utils';

interface StringMap {
	[key: string]: string;
}

interface ButtonGroupProps {
	filterEvent: (type: CourseResourceEnum) => void;
	types: StringMap;
}

const ButtonGroup = ({ types, filterEvent }: ButtonGroupProps) => {
	const initialType = { show: 'all' };

	const typeReducer = (_: StringMap, action: StringMap) => ({
		show: action.type,
	});

	const [state, dispatch] = useReducer(typeReducer, initialType);

	const handleFilter = (type: string) => {
		filterEvent(type as CourseResourceEnum);
		dispatch({ type });
	};

	return (
		<div className="flex items-center gap-3">
			<span className="text-[13px] text-muted-foreground font-medium">Filter by</span>
			<div className="inline-flex rounded-lg bg-muted p-1 gap-0.5">
				{Object.entries(types)
					.sort()
					.map((type: string[], i: number) => (
						<button
							key={`${type}-${i.toString()}`}
							type="button"
							onClick={() => handleFilter(type[1])}
							className={cn(
								'rounded-md px-3 py-1 text-[13px] font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring',
								state.show === type[1]
									? 'bg-background text-foreground shadow-sm'
									: 'text-muted-foreground hover:text-foreground'
							)}
						>
							{type[0]}
						</button>
					))}
			</div>
		</div>
	);
};

export default ButtonGroup;
